export const navEntries = [
  {
    src: 'assets/game-icons/lol.svg',
    name: 'LoL',
    gameType: 'leagueoflegends',
  },
  {
    src: 'assets/game-icons/dota.svg',
    name: 'Dota 2',
    gameType: 'dota2',
  },
  {
    src: 'assets/game-icons/csgo.svg',
    name: 'CSGO',
    gameType: 'counterstrike',
  },
  {
    src: 'assets/game-icons/valorant.svg',
    name: 'Valorant',
    gameType: 'valorant',
  },
  {
    src: 'assets/game-icons/rocketleague.svg',
    name: 'Rocket League',
    gameType: 'rocketleague',
  },
]